import { datadogRum } from '@datadog/browser-rum-slim';
import { EBEnvs, getCurrentEnv } from '@eventbrite/feature-detection';
import { trackInitialPageView } from '@eventbrite/site-analytics';
import { useEffect } from 'react';
import { useMount } from 'react-use';
import { useEnvContext, useRouteContext } from '../../../../context/';

export const useAnalyticsAndMonitoring = () => {
    const envContext = useEnvContext();
    const { location } = useRouteContext();

    const env = envContext?.env;
    const request = envContext?.request;
    const sessionId = request?.session_id;
    const gaSettings = envContext?.gaSettings;
    const pathname = location?.pathname;
    const search = location?.search;

    useEffect(() => {
        trackInitialPageView(gaSettings, {
            dimensions: { sessionId },
            location: window.location.href,
        });
    }, [pathname, search, gaSettings, sessionId]);

    useMount(() => {
        if (env && getCurrentEnv({ env }) === EBEnvs.PROD) {
            datadogRum.onReady(() =>
                datadogRum.addRumGlobalContext(
                    'view.sub_app',
                    'category-browse',
                ),
            );
        }
    });
};
